/*
 * @Author: zhouwei
 * @Date: 2019-10-18 13:58:32
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-03-12 18:56:45
 * @Desc: 统计数据
*/
<template>
  <div class="census">
    <mk-radio-group
      v-model="censusTitle"
      class="radio-group"
      size="mini"
    >
      <mk-radio-button label="基础数据"></mk-radio-button>
      <mk-radio-button label="销售参与统计"></mk-radio-button>
      <mk-radio-button label="覆盖线索统计"></mk-radio-button>
      <mk-radio-button label="行为标签统计"></mk-radio-button>
    </mk-radio-group>
    <mk-popover
      v-if="show"
      class="h-title"
      placement="left"
      trigger="hover"
      reference=""
    >
      <div
        class="h-t-popover"
        style="line-height:24px;"
        v-html="activeHtml"
      >
        <!-- <span style="font-weight: 500;">累计浏览量（PV）：</span>
        该表单的 累计⻚⾯浏览量，⽤户每次刷新即被计算⼀次。<br />
        <span style="font-weight: 500;">累计浏览人数（UV）：</span>
        该表单的累计页面浏览人数。每⽇（00:00-24:00）内相同的<br />
        访客只被计算⼀次。<br />
        <span style="font-weight: 500;">提交次数：</span>
        提交该表单内容的次数。 -->
      </div>
      <template slot="reference">
        <div class="tips">
          <mk-iconfont
            class="icon"
            icon-class="question-mark"
            style="color: #888;"
          ></mk-iconfont>
          <span>统计说明</span>
        </div>
      </template>
    </mk-popover>
    <basic v-if="censusTitle === '基础数据'"></basic>
    <sale
      v-if="censusTitle === '销售参与统计'"
      :task-list="taskList"
    ></sale>
    <clue v-if="censusTitle === '覆盖线索统计'"></clue>
    <be-tag
      v-if="censusTitle === '行为标签统计'"
      :task-list="taskList"
    ></be-tag>
  </div>
</template>
<script>
import basic from './basic.vue'
import sale from './sale.vue'
import clue from './clue.vue'
import beTag from './be-tag.vue'
export default {
  components: {
    basic,
    sale,
    clue,
    beTag
  },
  props: {
    taskList: {
      type: [Array, Object],
      default () {
        return []
      }
    }
  },
  data () {
    return {
      censusTitle: '基础数据',
      show: true,
      arrTips: [
        `
        <span style="font-weight: 500;">
          累计浏览量（PV）：
        </span>
        该资料的 累计⻚⾯浏览量，⽤户每次刷新即被计算⼀次。
        <br />
        <span style="font-weight: 500;">
          累计浏览人数（UV）：
        </span>
        该资料的累计页面浏览人数。每⽇（00:00-24:00）<br />
        内相同的访客只被计算⼀次。<br>
        <span style="font-weight: 500;">
          覆盖微信好友人数：
        </span>
        该资料已触达的工作手机微信好友人数。<br />
        <span style="font-weight: 500;">
          新增线索数：
        </span>
        该资料新增的销售线索数量。<br />
        <span style="font-weight: 500;">
          转发数：
        </span>
        该资料总共被转发的次数。
        `,
        `
        <span style="font-weight: 500;">
          线索来源：
        </span>
        展示线索来源渠道的数量占比，以浏览量PV来统计。 <br>
        <span style="font-weight: 500;">
          线索构成：
        </span>
        展示线索构成的新老线索/是否微信好友的数量占比，<br>以浏览线索数来统计。

      `
      ],
      activeHtml: `
        <span style="font-weight: 500;">
          累计浏览量（PV）：
        </span>
        该计划的累计页面浏览量，用户每次刷新即被计算⼀次。
        <br />
        <span style="font-weight: 500;">
          累计浏览人数（UV）：
        </span>
        该计划的累计页面浏览人数。每日（00:00-24:00）<br />
        内相同的访客只被计算一次。<br>
        <span style="font-weight: 500;">
          覆盖微信好友人数：
        </span>
        该计划已触达的工作手机微信好友人数。<br />
        <span style="font-weight: 500;">
          新增线索数：
        </span>
        该计划新增的销售线索数量。<br />
        <span style="font-weight: 500;">
          转发数：
        </span>
        该计划总共被转发的次数。
        `
    }
  },
  watch: {
    censusTitle (val) {
      if (val === '基础数据') {
        this.show = true
        this.activeHtml = this.arrTips[0]
      } else if (val === '销售参与统计') {
        this.show = false
        // this.activeHtml = ''
      } else if (val === '覆盖线索统计') {
        this.show = true
        this.activeHtml = this.arrTips[1]
      } else if (val === '行为标签统计') {
        this.show = false
        // this.activeHtml = ''
      }
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.census {
  width: calc(100% - 40px);
  min-width: 1080px;
  margin: 0 auto;
  margin-top: 20px;
  // display: flex;
  // justify-content: space-between;

  .radio-group {
    position: relative;
    z-index: 9;
    flex-shrink: 0;
  }

  .tips {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    height: 20px;
    float: right;
    margin-right: 18px;

    span {
      font-size: 14px;
      cursor: pointer;
      color: #888;
      font-weight: 500;
    }

    i {
      color: #888 !important;
      font-size: 16px;
      margin-right: 4px;
      font-weight: normal;
    }
  }

  .tips:hover {
    span {
      color: #109cff;
    }

    i {
      color: #109cff !important;
    }
  }
}
</style>
